import React from 'react'
import moment from 'moment'
import { Popup, Form } from 'semantic-ui-react'
import { DateRange } from 'react-date-range'
import 'moment/locale/cs'

const dateFormat = 'D. M. YYYY'

const onChangeHandler = (fieldFrom, fromValue, fieldTo, toValue) => {
  fieldFrom.onChange({ value: fromValue.startOf('day').toISOString() })
  fieldTo.onChange({ value: toValue.endOf('day').toISOString() })
}

const getMoment = (value, type = 'start') => {
  const alternativeDateFormat = 'DD.MM.YYYY'
  const formats = [`${dateFormat}`, `${alternativeDateFormat}`, moment.ISO_8601]
  if (!value) return ''
  if (value instanceof Date) {
    return moment(value)
  } else if (moment(value, formats, true).isValid()) {
    return moment(value, formats)
  } else if (Date.parse(value)) {
    return moment(Date.parse(value))
  }
  if (type === 'start') return value.startOf('day')
  return value.endOf('day')
}

const getLabel = (startDate, endDate) => {
  if (!startDate || !endDate) return ''
  return `${startDate.format(dateFormat)} - ${endDate.format(dateFormat)}`
}

class FromToFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      label: '',
    }
  }
  componentWillMount() {
    const { fieldFrom, fieldTo } = this.props
    const startDate = getMoment(fieldFrom.value, 'start')
    const endDate = getMoment(fieldTo.value, 'end')
    this.setState({ label: getLabel(startDate, endDate) })
  }

  componentWillReceiveProps(nextProps) {
    const startDate = getMoment(nextProps.fieldFrom.value, 'start')
    const endDate = getMoment(nextProps.fieldTo.value, 'end')
    this.setState({ label: getLabel(startDate, endDate) })
  }

  inputChanged(value) {
    const { fieldFrom, fieldTo } = this.props
    const formats = [dateFormat, 'DD. MM. YYYY', 'D.M.YYYY', 'DD.MM.YYYY', moment.ISO_8601]
    const formattedValue = value.replace(/\s/g, '')
    if (formattedValue === '') {
      fieldFrom.onChange({ value: '' })
      fieldTo.onChange({ value: '' })
      this.setState({
        label: value,
      })
      return
    }
    const parts = formattedValue.split('-')
    const startDate =
      parts[0] &&
      moment(parts[0], formats, true).isValid() &&
      moment(parts[0], formats)

    const endDate =
      parts[1] &&
      moment(parts[1], formats, true).isValid() &&
      moment(parts[1], formats)

    if (startDate && endDate) {
      fieldFrom.onChange({ value: startDate.startOf('day').toISOString() })
      fieldTo.onChange({ value: endDate.endOf('day').toISOString() })
      this.setState({
        label: value,
      })
    } else {
      this.setState({
        label: value,
      })
    }
  }

  render() {
    const { fieldFrom, fieldTo } = this.props
    const { label } = this.state

    const startDate = getMoment(fieldFrom.value, 'start')
    const endDate = getMoment(fieldTo.value, 'end')
    return (
      <Popup
        trigger={
          <Form.Input
            value={label}
            onChange={(e, { value }) => this.inputChanged(value)}
            placeholder="D.M.YYYY - D.M.YYYY"
          />
        }
        position="bottom center"
        on="click"
        wide
        flowing
      >
        <Popup.Content>
          <DateRange
            startDate={startDate}
            endDate={endDate}
            onChange={({ endDate, startDate }) =>
              onChangeHandler(fieldFrom, startDate, fieldTo, endDate)
            }
            format={dateFormat}
          />
        </Popup.Content>
      </Popup>
    )
  }
}

FromToFilter.propTypes = {
  fieldFrom: React.PropTypes.object.isRequired,
  fieldTo: React.PropTypes.object.isRequired,
}

export default FromToFilter



// WEBPACK FOOTER //
// ./src/browser/components/filters/FromToFilter.js